import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getSplitSupplyContractFormOptions } from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'
import {
  GetSplitSupplyContractFormOptionsRequestSchema,
  type GetSplitSupplyContractFormOptionsResponse,
} from '@ebalance/proto/bffuser/v1/occto_master_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 登録フォームの候補 (契約のない供給地点 / 自社の事業者 / 他社の事業者) の取得 hook。
 * 候補の業務判断は backend が持つ (BFF・frontend は絞らない)。
 */
export function useGetSplitSupplyContractFormOptions(): UseQueryResult<
  GetSplitSupplyContractFormOptionsResponse,
  ConnectError
> {
  return useQuery(
    getSplitSupplyContractFormOptions,
    create(GetSplitSupplyContractFormOptionsRequestSchema),
    // 本番の既定は throwOnError: true。 失敗の案内と「再試行」をフォームに出すため伝播させない
    { throwOnError: false },
  )
}
